export const formatPhoneNumber = (value: string): string => {
  // Удаляем все символы кроме цифр и плюса
  const cleaned = value.replace(/[^\d+]/g, '');
  
  // Если начинается с плюса, сохраняем его
  const hasPlus = cleaned.startsWith('+');
  const digits = cleaned.replace(/\+/g, '');
  
  // Если нет цифр, возвращаем пустую строку или плюс
  if (!digits) {
    return hasPlus ? '+' : '';
  }
  
  // Форматируем номер в зависимости от длины
  let formatted = digits;
  
  if (digits.length <= 2) {
    formatted = digits;
  } else if (digits.length <= 5) {
    formatted = `${digits.slice(0, 2)} ${digits.slice(2)}`;
  } else if (digits.length <= 8) {
    formatted = `${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5)}`;
  } else if (digits.length <= 11) {
    formatted = `${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5, 8)} ${digits.slice(8)}`;
  } else if (digits.length <= 14) {
    formatted = `${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5, 8)} ${digits.slice(8, 11)} ${digits.slice(11)}`;
  } else {
    formatted = `${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5, 8)} ${digits.slice(8, 11)} ${digits.slice(11, 14)} ${digits.slice(14, 17)}`;
  }
  
  return hasPlus ? `+${formatted}` : formatted;
};

export const cleanPhoneNumber = (value: string): string => {
  // Удаляем все символы кроме цифр
  return value.replace(/[^\d]/g, '');
};
